// extracted by mini-css-extract-plugin
export default {"menu":"Profile_menu__ciKI3","section":"Profile_section__cFaGg","sectionTitle":"Profile_sectionTitle__kL70L","menuItem":"Profile_menuItem__uMM7w","chevron":"Profile_chevron__VjSmN"};